import { flexMultiPrep } from './data-shared/flexMultiPrep.js';
import { flexPlus } from './recipes/flexPlus.js';

export const countertop = {
  id: '0-countertop',
  name: 'Countertop',
  levels: [
    {
      tileSize: 256,
      size: 256,
      fallbackOnly: true,
    },
    {
      tileSize: 512,
      size: 512,
    },
    {
      tileSize: 512,
      size: 1024,
    },
    {
      tileSize: 512,
      size: 2048,
    },
  ],
  faceSize: 2048,
  initialViewParameters: {
    yaw: -0.16451024236619816,
    pitch: 0.17724526712313526,
    fov: 1.5254872060750312,
  },
  linkHotspots: [
    {
      yaw: -1.142491121993288,
      pitch: -0.02311075179714983,
      rotation: 14.922565104551524,
      target: '1-dining',
    },
    {
      yaw: -0.5010495593355557,
      pitch: -0.07969055878697162,
      rotation: 9.42477796076938,
      target: '4-left',
    },
    {
      yaw: -0.7238733145132628,
      pitch: -0.010621314280680139,
      rotation: 3.141592653589793,
      target: '2-island',
    },
    {
      yaw: 0.014681269632129457,
      pitch: -0.019611923210588245,
      rotation: 34.55751918948774,
      target: '5-right',
    },
    {
      yaw: -0.18244700943043135,
      pitch: 0.4659703845133265,
      rotation: 14.137166941154074,
      target: '3-range',
      class: 'second-tour-starter',
    },
  ],
  infoHotspots: [
    {
      yaw: -0.8783218019424197,
      pitch: 0.335263916491801,
      ...flexMultiPrep,
      recipes: flexPlus.recipes,
    },
    {
      yaw: 0.331594607164386,
      pitch: 0.20994667996391003,
      title: 'Pizza Crust Mix',
      text: `
<ul>
<li><span class="b">#100698</span></li>
<li><span class="b">USD</span> $7 | <span class="b">CAD</span> $9</li>
<li> Kosher | Contains wheat, barley, and milk. </li>
<li> 6.1 oz. (173 g); makes one 12” (30-cm) round crust</li>
<li> Improved recipe so it’s crispier and even more flavorful. </li>
<li> Enjoy a delicious pizza with all the flavor and crispy texture you love in under 30 minutes—less time than it takes to get one delivered. </li>
<li> Simply add water and oil (mix includes yeast), knead for 5 minutes, and let rest for 5 minutes. Then add your favorite sauce and toppings.</li>
<li> We recommend baking on a pizza stone, but a baking sheet works just fine. </li>

</ul>
        `,
      images: [
        { id: `kzfell7t3x`, key: `nc1-gs1-15` },
        { id: `gawy0rg1dj`, key: `nc1-gs1-16` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999875" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`,
      ],
    },
    {
      yaw: 0.5092270951767273,
      pitch: 0.47962617685085185,
      title: 'Adjustable Graters<br/> & Zester',
      text: `
<ul>
<br/>
<span class="title">Adjustable Graters & Zester Collection</span>
<li>3-year guarantee</li>
<li>Dishwasher-safe</li>
<li>Made using a chemical process that etches the blades to create super sharp edges.</li>
<li>Nonskid feet will keep it secure on your work surface. </li>
<li>Soft grip handle lets you comfortably grate large amounts of food.</li>
<li>Folds flat so you can easily store it in a kitchen drawer.</li>
<br/>
<span class="title">Adjustable Double Grater</span>
<li><span class="b">#100472</span></li>
<li><span class="b">USD</span> $55 | <span class="b">CAD</span> $75</li>
<li> 11" (28 cm) tall; container holds 2 cups (500 mL)</li>
<li> Includes two graters (extra coarse and fine) with stainless-steel, chemically etched blades, a food holder and pusher, food container with measurement markings, and protective covers for storage.</li>
<li> Use it fully assembled to grate mess-free over the included food container. Or, you can separate the two graters to use over a bowl, serving dish, or cutting board.</li>
<li><span class="b">Great for:</span> cheese, hash browns, finely shredded carrots for cake, pastas, tacos, and stir-fries.</li>
<br />
<span class="title">
    Adjustable Coarse Grater
</span>
<li><span class="b">#100481</span></li>
<li> <span class="b">USD</span> $40 | <span class="b">CAD</span> $52</li>
<li> 12¾" (32 cm) when open</li>
<li> Includes a coarse grater with stainless steel, chemically etched blades, a food holder and pusher, and protective cover for storage.</li>
<li> Use in two positions: standing, or extended over a plate or bowl.</li>
<li> <span class="b">Great for:</span> cheese, fruit, veggies, chocolate, coleslaw, hash browns, dips, soups, and more.</li>
<br/>
<span class="title">Adjustable Zester</span>
<li> <span class="b">#100482</span></li>
<li> <span class="b">USD</span> $30 | <span class="b">CAD</span> $35</li>
<li> 12¾" (32 cm) when open</li>
<li> Includes zester with stainless steel, chemically etched blades, a food holder and pusher, and protective cover for storage.</li>
<li> Use in two positions: standing, or extended over a plate or bowl.</li>
<li> Elongated zesting blade lets you easily zest large amounts.</li>
<li> <span class="b">Great for:</span> lemons, limes, oranges, cheese, chocolate, garlic, ginger, and nutmeg.</li>
</ul>
        `,
      images: [
        { id: `1vsxvlvjtz`, key: `nc1-gs1-17` },
        { id: `cxo9drl2en`, key: `nc1-gs1-18` },
        { id: `h5y0smdha7`, key: `nc1-gs1-19` },
        { id: `0sbhhurboi`, key: `nc1-gs1-20` },
        { id: `15ldelidb2`, key: `nc1-gs1-21` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570478088" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
  ],
};
